import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CreateProspectorContacts as CreateProspectorContactsMutation,
    CreateProspectorContactsVariables as CreateProspectorContactsMutationVariables,
    ProspectorContactsAddInput,
} from 'nutshell-graphql-types';

import GET_UNLOCK_INFO from '../../../../../people-iq/graphql/queries/get-unlock-info.graphql';

import CREATE_PROSPECTOR_CONTACTS from '../mutations/create-prospector-contacts.graphql';

export const useCreateProspectorContacts = (): {
    createProspectorContacts: (input: ProspectorContactsAddInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [createProspectorContacts, {loading, error}] = useMutation<
        CreateProspectorContactsMutation,
        CreateProspectorContactsMutationVariables
    >(CREATE_PROSPECTOR_CONTACTS, {
        refetchQueries: [{query: GET_UNLOCK_INFO}],
    });

    return {
        createProspectorContacts: (input: ProspectorContactsAddInput) => {
            return createProspectorContacts({
                variables: {input},
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
